// Collapse the final clipped slide into the last reachable scroll position.
export function justDryStops(offsets, maximum) {
  const max = Math.max(0, maximum);
  return [...new Set([0, ...offsets.map(x => Math.round(Math.max(0, Math.min(x, max)))), Math.round(max)])].sort((a,b) => a-b);
}
class LaasaJustDrySlider extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const {signal} = this.abort;
    this.track = this.querySelector('.laasa-justdry__track');
    this.items = [...this.querySelectorAll('.laasa-justdry__item')];
    this.navigation = this.querySelector('.laasa-justdry__navigation');
    this.previous = this.querySelector('[data-justdry-prev]');
    this.next = this.querySelector('[data-justdry-next]');
    this.counter = this.querySelector('[data-justdry-counter]');
    if (!this.track || !this.navigation || !this.previous || !this.next || !this.counter) return;
    this.previous.addEventListener('click', () => this.move(-1), {signal});
    this.next.addEventListener('click', () => this.move(1), {signal});
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.update());
    }, {signal, passive:true});
    this.track.addEventListener('keydown', event => {
      if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault();this.move(event.key === 'ArrowRight' ? 1 : -1);
    }, {signal});
    this.resize = new ResizeObserver(() => this.update());
    this.resize.observe(this.track);
    this.items.forEach(item => this.resize.observe(item));
    document.addEventListener('shopify:block:select', event => {
      const item=event.target.closest?.('.laasa-justdry__item');
      if(item && this.contains(item)) this.track.scrollTo({left:item.offsetLeft-this.items[0].offsetLeft,behavior:'instant'});
    }, {signal});
    this.update();
  }
  update() {
    const first = this.items[0]?.offsetLeft || 0;
    const max = this.track.scrollWidth-this.track.clientWidth;
    this.stops = justDryStops(this.items.map(item => item.offsetLeft-first),max);
    this.active = this.stops.reduce((best,stop,index) => Math.abs(stop-this.track.scrollLeft)<Math.abs(this.stops[best]-this.track.scrollLeft) ? index : best,0);
    this.navigation.hidden = max < 2;
    this.previous.disabled = this.active === 0;
    this.next.disabled = this.active === this.stops.length-1;
    this.counter.textContent = `${this.active+1} / ${this.stops.length}`;
  }
  move(direction) {
    this.update();
    const target=Math.max(0,Math.min(this.stops.length-1,this.active+direction));
    this.track.scrollTo({left:this.stops[target],behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame)}
}
if(!customElements.get('laasa-justdry-slider'))customElements.define('laasa-justdry-slider',LaasaJustDrySlider);
